import { Directive, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({ selector: '[middleClick]' })
export class MiddleClickDirective  {
  @Output() middleClick = new EventEmitter();

  constructor() {}

  @HostListener('mouseup', ['$event'])
  middleClickEvent(event): void {
    if (event.which === 2) {
      this.middleClick.emit(event);
    }
  }
}
